import { j as e } from "../../../../jsx-runtime.BREq8dyb.js";
import { useBoolean as h } from "@decentriq/hooks";
import { faEyeSlash as y, faEye as C } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as a } from "@fortawesome/react-fontawesome";
import { FormControl as k, FormLabel as S, Input as w, FormHelperText as D, Tooltip as F, IconButton as I } from "@mui/joy";
import { memo as b } from "react";
import { b as g, C as B } from "../../../../react-hook-form.Du3weLRK.js";
const E = b(({
  label: m,
  name: o,
  placeholder: d,
  required: c = !0,
  type: r,
  ...p
}) => {
  const {
    control: x
  } = g(), [t, {
    toggle: f
  }] = h(!0);
  let s = {
    type: r
  };
  switch (r) {
    case "masked":
      s = {
        autoComplete: "new-password",
        endDecorator: /* @__PURE__ */ e.jsx(F, { title: t ? "Show" : "Hide", children: /* @__PURE__ */ e.jsx(I, { onClick: f, children: t ? /* @__PURE__ */ e.jsx(a, { fixedWidth: !0, icon: C }) : /* @__PURE__ */ e.jsx(a, { fixedWidth: !0, icon: y }) }) }),
        style: {
          WebkitTextSecurity: t ? "disc" : "none"
        },
        type: "text"
      };
      break;
  }
  return /* @__PURE__ */ e.jsx(B, { control: x, name: o, render: ({
    field: {
      disabled: n,
      value: u = "",
      ...j
    },
    fieldState: {
      error: l
    },
    formState: {
      isSubmitting: i
    }
  }) => /* @__PURE__ */ e.jsxs(k, { disabled: n || i, error: !!l, required: c, children: [
    /* @__PURE__ */ e.jsx(S, { children: m }),
    /* @__PURE__ */ e.jsx(w, { disabled: n || i, placeholder: d, value: u, ...s, ...p, ...j }, o),
    /* @__PURE__ */ e.jsx(D, { children: l?.message })
  ] }) }, o);
});
E.displayName = "DqDatasetSyncControlledInput";
export {
  E as default
};
//# sourceMappingURL=DqDatasetSyncControlledInput.js.map
